import { put, select, takeEvery } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import i18next from 'i18next'
import { List, Map } from 'immutable'
import { CHANGE_BUTTON_TYPES } from '@prohabits/metaverse'

import { EStoppedFrom } from 'store/entities/identity/interface'
// import * as routes from 'app/domains/routes/constants'
import { PROCEED, SELECTION } from 'app/constants/stages'
import { userInfoFromHash } from 'store/entities/router/selectors'
import { register, sendError } from 'store/entities/analytics/actions'
import { ERRORS } from 'store/entities/analytics/consts'
import { isResponseFailed } from 'helpers/responseHelpers'
import { showTypeFormPopup } from 'store/entities/typeform/actions'
import { store } from 'store'
import {
  activityActions,
  authLogin,
  getIdentityProgress,
  getProfile,
  subscribeToProTrack,
  transferUserToOtherOrg,
  updateSubscribeToProTrack,
} from '../actions'
import {
  setConfirmationModal,
  setConfirmationModalForCommitPreviousActivity,
  setConfirmationModalForDifferentProTrack,
  setConfirmationModalForStopProTrack,
  setQueries,
  setShouldAutoPlayVideo,
  triggerCommitOrDidPreviousActivities,
} from 'store/entities/localSettings/actions'
import { handleExternalRedirectQuery } from 'store/entities/router/actions'
import {
  getCurrentProTrackProgressDay,
  getIdentityActiveProTrackId,
  getIdentityCanCompletePreviousActivityInWorkday,
  getIdentityLastUserActivity,
  getIdentityStage,
  getOnboardingNewProTrackLevels,
  isBeginSurveySubmitted,
  isEndSurveySubmitted,
  isIdentityActiveProTrackAutoEnroll,
  isStageIsSelection,
  isUserEverTakeProTrack,
} from '../selectors'
import { showInfo } from 'store/entities/toastr/utils'
import { WORK_WEEK_EVERY_OTHER_DAY, WORK_WEEK_ONCE_A_WEEK, WORK_WEEK_TWICE_A_WEEK } from 'app/constants/profile'
import { COMMIT, DID, NULL } from 'app/constants/identityActions'
import { saveProfile, updateOnboardingChecklist, userActivityClick } from 'store/entities/identity/actions'
import { getOnboardingChecklist } from 'store/entities/identity/selectors'
import { IS_QUIZ_COMPLETED } from 'app/constants/onBoarding'
import { getSeparatedUrlAndQueryString, parseQuery } from 'helpers/urlHelper'
import { getActivityUserActivityId, getActionType, getActivityId } from 'store/entities/activity/selectors'
import { ACTIVITIES, DASHBOARD } from 'app/domains/routes/constants'

export function* authLoginSuccessHandler({ payload }) {
  try {
    const query = yield select(userInfoFromHash)
    if (!query || !query.has('token') || !query.has('uid')) {
      yield put(
        sendError({
          type: ERRORS.AUTH_LOGIN_SUCCESS_HANDLER,
          error: new Error('query is wrong'),
          query,
        })
      )
      yield put(push('/'))
      return
    }

    // 1. register with analytics
    const { first_login, id, isLoginFlowFinished } = payload
    yield put(register(id, first_login))
    // if (!isLoginFlowFinished) {
    //   yield put(push(`/${routes.TOUR}`));
    // }

    // 2. get profile
    const resProfile = yield getProfile.call()
    if (isResponseFailed(resProfile)) {
      throw new Error('Get Profile Error')
    }

    // 3. get progress
    const resProgress = yield getIdentityProgress.call()
    if (isResponseFailed(resProgress)) {
      throw new Error('Get Progress Error')
    }

    const stage = yield select(getIdentityStage)

    let internalRedirect = ''
    const externalRedirectLink = query.get('externalRedirectLink')

    const proTrackLevelId = parseInt(query.get('protracklevelid'))

    // 4. Invitation
    const isInvitation = query.get('invitation')
    if (isInvitation) {
      // 4.a if clicks on invitation email or text message 2nd or more times
      if (!first_login) {
        const activeLevelId = yield select(getIdentityActiveProTrackId)
        const isAutoEnroll = yield select(isIdentityActiveProTrackAutoEnroll)
        // from email
        if (proTrackLevelId) {
          const newProTracksLevels = yield select(getOnboardingNewProTrackLevels)
          const proTrackName = newProTracksLevels
            .filter(el => el.get('id') === proTrackLevelId)
            .getIn(['0', 'proTrackName'])
          if (proTrackLevelId === activeLevelId) {
            const isAutoAcceptedUser = query.get('autoAccept')
            const actionType = yield select(getActionType)
            // do commit for the autoAccpeted user in case when he will login from the invitation email
            if (isAutoAcceptedUser && actionType === null) {
              const userActivityId = yield select(getActivityUserActivityId)
              const activityId = yield select(getActivityId)
              yield activityActions[COMMIT].call({ activityId, userActivityId, actionSource: 'email' })
            } else {
              showInfo({ content: i18next.t('Welcome back! You are on', { proTrackName }) })
            }
          } else {
            const currentProTrackProgressDay = yield select(getCurrentProTrackProgressDay)
            const isSelection = yield select(isStageIsSelection)
            if (currentProTrackProgressDay < 2 && isAutoEnroll && !isSelection) {
              yield put(updateSubscribeToProTrack({ proTrackLevelId }))
            }
            if (isSelection) {
              yield put(subscribeToProTrack({ proTrackLevelId, isSubscriptionFromEmail: true }))
              // keep old flow if external redirect don't exist
              if (!externalRedirectLink) {
                return
              }
            } else {
              yield put(setQueries({ proTrackLevelId, proTrackName, stopSource: EStoppedFrom.INVITE }))
              // need update unsubscribe for subscribing after unsubscribed
              yield put(setConfirmationModal(true))
            }
          }
        }

        // from phone
        if (!proTrackLevelId && ((activeLevelId && isAutoEnroll) || !isLoginFlowFinished || !isUserEverTakeProTrack)) {
          yield put(push('/on-boarding-landing'))
          return
        }
      }

      // 4.b if user clicks on invitation email or text message first time
      if (first_login) {
        // show on-boarding landing page if user came from invitation text message
        if (!proTrackLevelId) {
          yield put(push('/on-boarding-landing'))
          return
        }
        // save proTrackLevelId if user came from invitation email and subscribe
        if (proTrackLevelId) {
          const isAutoEnroll = yield select(isIdentityActiveProTrackAutoEnroll)
          const activeLevelId = yield select(getIdentityActiveProTrackId)
          const isSelection = yield select(isStageIsSelection)
          if (isAutoEnroll && activeLevelId) {
            yield put(updateSubscribeToProTrack({ proTrackLevelId, autoEnroll: false }))
          } else if (isSelection) {
            yield put(subscribeToProTrack({ proTrackLevelId, isSubscriptionFromEmail: true }))
            // keep old flow if external redirect don't exist
            if (!externalRedirectLink) {
              return
            }
          }
        }
      }
    }

    if (query.get('autoPlay')) {
      yield put(setShouldAutoPlayVideo(true))
    }

    const onboardingChecklist = yield select(getOnboardingChecklist)
    const typeFormLink = query.get('typeFormLink')
    const isBeginSubmitted = yield select(isBeginSurveySubmitted)
    const isEndSubmitted = yield select(isEndSurveySubmitted)

    if (typeFormLink) {
      const formLink = atob(typeFormLink)
      const typeFormData = {}

      const { url: surveyUrl, queryString } = getSeparatedUrlAndQueryString(formLink)

      const hiddenOptionsToSend = parseQuery(queryString)
      typeFormData.formId = surveyUrl.split('/').reverse()[0]
      typeFormData.hidden = hiddenOptionsToSend

      if (
        (formLink.indexOf('type=begin') !== -1 || formLink.indexOf('type=end') !== -1) &&
        (isBeginSubmitted || isEndSubmitted)
      ) {
        // if user has already sent beginSurvey or endSurvey
        showInfo({ content: 'You have already used this link to take the quiz' })
      } else {
        yield put(
          showTypeFormPopup({
            typeFormData,
            onSubmit: () => {
              if (!onboardingChecklist[IS_QUIZ_COMPLETED]) {
                return store.dispatch(
                  updateOnboardingChecklist({ propertyName: IS_QUIZ_COMPLETED, propertyValue: true })
                )
              }
            },
          })
        )
      }
    }

    // 5. handle selectNewProTrack if exists or redirect
    const isSelectNewProTrack = query.get('selectnewprotrack')
    const redirect = query.get('redirect')
    const changeButtonType = query.get('changeButtonType')
    const redirectUrl = {
      frequency: 'profile/notifications',
      proTrack: 'profile/active-protracks',
      textNotifications: 'profile/notifications',
      outOfOffice: 'profile/out-of-office',
      timePreference: 'profile/notifications',
      home: 'dashboard',
      settings: 'dashboard/profile',
      support: 'support',
    }

    if (stage === SELECTION && isSelectNewProTrack) {
      yield put(push('/select-protrack'))
      showInfo({ content: 'Please continue selecting your ProTrack' })
      return
    } else if (changeButtonType) {
      const url = redirectUrl[changeButtonType]
      const daysWithProtrack = yield select(getCurrentProTrackProgressDay)
      const userActivityId = parseInt(query.get('userActivityId'))
      const emailType = query.get('emailType')
      yield put(push({ pathname: `/${url}` }))
      yield put(
        userActivityClick({
          userActivityId,
          changeButtonType,
          source: emailType,
          enrolledDays: daysWithProtrack,
        })
      )
      return
    } else if (redirect) {
      yield put(push({ pathname: `/${redirect}` }))
      return
    }

    // 6. handle stop protrack from email
    const isStopProtrack = query.get('stopProtrack')
    const stopSource = query.get('stopSource')

    if (stage === PROCEED && isStopProtrack) {
      yield put(setQueries({ stopSource }))
      yield put(setConfirmationModalForStopProTrack(true))
      yield put(push('/dashboard'))
      return
    }

    // 7. handle different protrack from email
    const isDifferentProTrack = query.get('differentProtrack')
    yield put(setQueries({ stopSource }))
    if (stage === PROCEED && isDifferentProTrack) {
      yield put(setConfirmationModalForDifferentProTrack(true))
    }

    // 8. Transfer user to another organization
    const isTransfer = query.get('transfer')
    const transferTo = query.get('transferTo')

    if (isTransfer) {
      if (proTrackLevelId) {
        // from email
        yield put(setQueries({ transferTo, proTrackLevelId }))
      } else {
        // from phone
        yield put(setQueries({ transferTo }))
      }
      yield put(transferUserToOtherOrg({ organizationId: transferTo }))
      return
    }

    // 9. handle action if exists
    // Must be as like last action.
    // We will be have bug with rate and leave story for ast activity in ProTrackLevel if getIdentityProgress will be after activityActions[did]
    const action = query.get('action')
    const activityId = parseInt(query.get('activityId'))
    const userActivityId = parseInt(query.get('userActivityId'))
    const canCompletePreviousActivity = yield select(getIdentityCanCompletePreviousActivityInWorkday)

    if (action && action !== NULL && activityId) {
      if (!activityActions[action]) {
        throw new Error(`Unexpected action with name: ${action}`)
      }
      const previousActivity = yield select(getIdentityLastUserActivity)
      const currentActivityUserActivityId = yield select(getActivityUserActivityId)
      const activeLevelId = yield select(getIdentityActiveProTrackId)
      const previousUserActivityId = previousActivity.get('userActivityId')
      const previousActionType = previousActivity.get('actionType')
      const itIsPreviousActivity = previousUserActivityId === userActivityId
      const itIsTodayActivity = currentActivityUserActivityId === userActivityId
      const itIsDidPreviousActivity = DID === action && itIsPreviousActivity && previousActionType === COMMIT
      const itIsCommitPreviousActivity = previousActionType === null && itIsPreviousActivity
      // @test1 look authLoginSuccess.test.js
      if (canCompletePreviousActivity && action === COMMIT && itIsTodayActivity) {
        // Show popup if user does commit for today activity but previous is committed but not done
        yield put(setConfirmationModalForCommitPreviousActivity(true))
        // @test2 look authLoginSuccess.test.js
      } else if (activeLevelId && (itIsTodayActivity || itIsDidPreviousActivity || itIsCommitPreviousActivity)) {
        const commitResponse = yield activityActions[action].call({ activityId, userActivityId, actionSource: 'email' })
        if (isResponseFailed(commitResponse)) {
          yield getProfile.call()
          yield getIdentityProgress.call()
          // if external redirect doesn't exist we have to stop saga flow
          if (!externalRedirectLink) {
            throw new Error('Commit error')
          }
        }
        // @test3 look authLoginSuccess.test.js
      } else {
        yield put(triggerCommitOrDidPreviousActivities({ activityId, userActivityId, action }))
        yield put(push({ pathname: `/${ACTIVITIES}` }))
        // without external link in this case we have to stop saga executing to push user to activities page
        if (!externalRedirectLink) {
          return
        }
        // flag for case when we have external redirect and user click on old email where activity not available for now
        internalRedirect = `/${ACTIVITIES}`
      }
    }
    // 10. handle external redirect
    if (externalRedirectLink) {
      yield put(handleExternalRedirectQuery(query.set('internalRedirect', internalRedirect)))
      return
    }

    // 11. set new work week
    const changeNotificationFrequencyType = query.get('frequencyType')
    if (changeNotificationFrequencyType) {
      let workWeek
      switch (changeNotificationFrequencyType) {
        case 'everyOtherDay':
          workWeek = WORK_WEEK_EVERY_OTHER_DAY
          break
        case 'twiceAWeek':
          workWeek = WORK_WEEK_TWICE_A_WEEK
          break
        case 'onceAWeek':
          workWeek = WORK_WEEK_ONCE_A_WEEK
          break
      }
      if (!workWeek) {
        throw new Error(`Unexpected work week: ${workWeek}`)
      }
      yield put(saveProfile(Map({ workWeek: List(workWeek) })))
      yield put(push('/dashboard/profile'))
      return
    }

    // 12. Login from sms activity notification
    const actionSource = query.get('actionSource')
    if (actionSource === 'sms') {
      yield put(push(`/${DASHBOARD}?actionSource=sms`))
      return
    }

    // 13. If an unactivated user is busy in support
    if (!isLoginFlowFinished && changeButtonType === CHANGE_BUTTON_TYPES.SUPPORT) {
      const url = redirectUrl[changeButtonType]
      yield put(push({ pathname: `/${url}` }))
    }

    yield put(push(`/${DASHBOARD}`))
  } catch (error) {
    yield put(
      sendError({
        type: ERRORS.AUTH_LOGIN_SUCCESS_HANDLER,
        error,
      })
    )
    yield put(push('/'))
  }
}

export default function* authLoginSuccessEvery() {
  yield takeEvery(authLogin.success.toString(), authLoginSuccessHandler)
}
